import { fetchOrderAttributes } from '@/entities/attributes/thunks/fetchOrderAttributes'
import { fetchDepotLites } from '@/entities/depots/thunks/fetchDepotLites'
import { fetchScenarios } from '@/entities/schedules/thunks/fetchScenarios'
import { completeLoadingState } from '@/entities/userInterface/slices/loaderSlice'
import { createAsyncThunk } from '@reduxjs/toolkit'

// This asynchronous function is designed to initialize and set up global state in the Redux store related to the import wizard page.
export const setupImportWizard = createAsyncThunk('importWizard/setup', async (_, { dispatch }) => {
  await Promise.allSettled([
    dispatch(fetchDepotLites()),
    dispatch(fetchOrderAttributes()),
    dispatch(fetchScenarios({ scenarioIds: [] })),
  ])

  dispatch(completeLoadingState())
})